import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GenericTreeDragDropService {
  isDragging = signal(false);

  dragStarted(): void {
    this.isDragging.set(true);
  }

  dragEnded(): void {
    this.isDragging.set(false);
  }
}
